var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-10",attrs:{"row":"","fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }